(() => {
  if (window.__F24ProductConversionLoaded) return;
  window.__F24ProductConversionLoaded = true;

  const reviewTarget = () => document.querySelector('#judgeme_product_reviews')
    || document.querySelector('[data-f24-judgeme-reviews]')
    || document.querySelector('.jdgm-rev-widg');

  const jumpToReviews = () => {
    const target = reviewTarget();
    if (!target) return false;

    const details = target.closest('details') || document.querySelector('#f24-customer-reviews');
    if (details instanceof HTMLDetailsElement && !details.open) details.open = true;

    target.setAttribute('tabindex', '-1');
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(() => target.focus({ preventScroll: true }), 420);
    });
    return true;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-f24-review-jump], .jdgm-prev-badge');
    if (!trigger || !reviewTarget()) return;
    event.preventDefault();
    jumpToReviews();
  });
})();
